"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _skeletons = require("../../../../icons-react/skeletons");
var ClientCardSkeleton = /*#__PURE__*/_react["default"].memo(function (props) {
  return /*#__PURE__*/_react["default"].createElement(StyledClientCardSkeleton, props, /*#__PURE__*/_react["default"].createElement(StyledSkeletonIcon, null));
});
ClientCardSkeleton.displayName = 'ClientCardSkeleton';
ClientCardSkeleton.propTypes = {
  className: _propTypes["default"].string
};
ClientCardSkeleton.defaultProps = {
  className: ''
};
var StyledClientCardSkeleton = _styledComponents["default"].div.withConfig({
  displayName: "ClientCardSkeleton__StyledClientCardSkeleton",
  componentId: "sc-1hq60n1-0"
})(["display:block;"]);
var StyledSkeletonIcon = (0, _styledComponents["default"])(_skeletons.ClientCard).withConfig({
  displayName: "ClientCardSkeleton__StyledSkeletonIcon",
  componentId: "sc-1hq60n1-1"
})(["width:264px;height:123px;animation:fade 0.1s ease;@keyframes fade{from{opacity:0;}}"]);
var _default = exports["default"] = ClientCardSkeleton;